import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

function Card({ children, sx }) {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'white',
        borderRadius: '5px',
        m: 1,
        p: 2,
        boxShadow: 1,
        ...sx
      }}
    >
      {children}
    </Box>
  );
}

Card.propTypes = {
  children: PropTypes.any,
  sx: PropTypes.any
};

export { Card };
